import * as ImageManipulator from 'expo-image-manipulator';
import * as ImagePicker from 'expo-image-picker';

import { PhotoLibraryPermissionDeniedError, PhotoPickCancelledError, PhotoReadFailedError } from '@/lib/photo-errors';
import { resizeTarget } from '@/lib/photo-resize';

// The one pick -> shrink -> encode path (issue #414). No base64 from the
// picker: encoding the full-resolution original is the expensive part, so
// shrink first and encode only the small result.
export async function pickShrunkPhoto(): Promise<{ base64: string; mimeType: 'image/jpeg' }> {
  const permission = await ImagePicker.requestMediaLibraryPermissionsAsync();
  if (!permission.granted) throw new PhotoLibraryPermissionDeniedError();

  const result = await ImagePicker.launchImageLibraryAsync({ mediaTypes: ['images'], quality: 1 });
  if (result.canceled) throw new PhotoPickCancelledError();

  const asset = result.assets[0];
  if (!asset) throw new PhotoReadFailedError();

  const resize = resizeTarget(asset.width, asset.height);
  const shrunk = await ImageManipulator.manipulateAsync(asset.uri, resize ? [{ resize }] : [], {
    compress: 0.7,
    format: ImageManipulator.SaveFormat.JPEG,
    base64: true,
  });
  if (!shrunk.base64) throw new PhotoReadFailedError();

  return { base64: shrunk.base64, mimeType: 'image/jpeg' };
}
